<template>
    
    <div>

    	<section 
			:class="{'outer-pad': true }"
		>

			<Table 
				:headings="tableHeadings" 
				:items="paymentMethods.current" 
				:pages="1"
				:page="1"
				:count="1"
				emptyLabel="There are no payment methods at the moment"
				@makeCurrent="makeCurrent"
				@delete="deletePaymentMethod"
				@addNew="showPayment=true"
				addNewButtonLabel="Add a new payment method"
				:loading="loadingPaymentMethods"
				:loadingText="loadingPaymentMethodsText"
				v-if="!isNotStripeCustomer"
			/>

			<div class="info-panel no-subscription" v-if="isNotStripeCustomer">

				<h3>Please setup your subscription</h3>

				<p>You only need to use this area if you want to change the payment method used on your subscription.<br><br>To start your subscription and enter your card details please head over to the <router-link to="/account/subscriptions/" title="Subscriptions">Subscriptions tab</router-link>.
				</p>

			</div>

			<h3 class="expired-title" v-if="paymentMethods.old.length>0">Expired Payment Methods</h3>

			<Table   
				:headings="tableHeadingsOld" 
				:items="paymentMethods.old" 
				:pages="1"
				:page="1"
				:count="1"
				emptyLabel="There are no expired payment methods at the moment"
				v-if="paymentMethods.old.length>0"
			/>

		</section>

		<Payment 
			v-if="showPayment" 
			title="Add a Payment Method"
			:requireAddress="true"
			type="new"
			@close-payment="closePayment" 
		/>

    </div>

</template>

<script>
import Vue from 'vue';
import { mapMutations } from 'vuex'
import ApiService from './../../services/api.service'
import general from './../../utils/general'
import Table from './../../components/Table.vue' 
import TableButton from './../../components/Display/TableButton.vue'
import Payment from './../../components/Payment.vue';
export default {
  	name: 'PaymentMethods',
  	components: {
	    Table, Payment 
	},
  	props: {},
  	data() {

		return {
			tableHeadings: {
				created: { value: 'Created', dateFormat: 'jS M Y @ g:i a' },
				brand: { value: 'Type' },
				cardNumber: { value: 'Last 4' },
				expiry: { value: 'Expiry' },
				selected: { value: 'Current', component: TableButton, event: 'makeCurrent' },
				delete: { value: '', component: TableButton, event: 'delete' }
			},
			tableHeadingsOld: {
				created: { value: 'Created', dateFormat: 'jS M Y @ g:i a' },
				brand: { value: 'Type' },
				cardNumber: { value: 'Last 4' },
				expiry: { value: 'Expiry' },
				delete: { value: '', component: TableButton, event: 'delete' }
			},
			table: {
				pages: 1,
				page: 1, 
				count: 1
			},
			info: {},
			paymentMethods: { current: [], old: [] },
			showPayment: false,
			isStripeCustomer: false,
			loadingPaymentMethods: true,
			loadingPaymentMethodsText: 'Fetching payment methods...'
		}

	},
	computed: {

		isNotStripeCustomer () {

			return !this.isStripeCustomer && !this.loadingPaymentMethods;

		}

	},
	methods : {

		...mapMutations('general',['updateLoadingText']),

		deletePaymentMethod ( { id, cardNumber, brand } ) {

			this.$dialog
				.confirm( 'Delete the '+brand+' ending '+cardNumber + '?', { okText: 'Yes please', cancelText: 'Cancel',})
				.then(function() {

					this.updateLoadingText('One moment...');
					
					ApiService.delete( 'payment/methods/' + id )
					.then( function( info ) {

						this.$snotify.success( info.data, 'Delete Payment Method' );
						this.updateLoadingText();
						this.getPaymentMethods ();

					}.bind(this))
					.catch( function(err) {

						this.$snotify.error( err.response.data.error, 'Delete Payment Method' );
						this.updateLoadingText();

					}.bind(this));

				}.bind(this))
				.catch(function(err) {}.bind(this));

		},

		makeCurrent ( { id, cardNumber, brand } ) {

			this.$dialog
				.confirm( 'Make the '+brand+' ending '+cardNumber+' the default for all future payments?', { okText: 'Yes please', cancelText: 'Cancel',})
				.then(function() {

					this.updateLoadingText('One moment...');
					
					ApiService.put( 'payment/methods', { paymentMethodId: id } )
					.then( function( info ) {

						this.$snotify.success( info.data, 'Change Payment Method' );
						this.updateLoadingText();
						this.getPaymentMethods ();

					}.bind(this))
					.catch( function(err) {

						this.$snotify.error( err.response.data.error, 'Change Payment Method' );
						this.updateLoadingText();

					}.bind(this));

				}.bind(this))
				.catch(function(err) {}.bind(this));

		},
		closePayment(info) {

			this.showPayment = false;
			general.modalClose();
			this.getPaymentMethods ();

		},
		getPaymentMethods () {

			this.loadingPaymentMethods = true;

			ApiService.get( 'payment/methods' )
			.then( function( info ) {

				Vue.set( this, 'paymentMethods', info.data );

				this.loadingPaymentMethods = false;

				this.isStripeCustomer = info.data['is-stripe-customer'];

			}.bind(this))
			.catch( function(err) {
				console.log(err);
				this.loadingPaymentMethodsText = 'There was an error fetching your payment methods, if this persists please contact us.';
			}.bind(this));

		}

	},
	created() {

		this.getPaymentMethods ();

	}
}
</script>

<style lang="less" scoped>
@import './../../assets/css/less/_settings.less';
@import './../../assets/css/less/_helper.less';
.expired-title {
	margin: 30px 0 20px;
}
.no-subscription {
	p {
		a {
			color: @formDefaultColour;
		}
	}
}
</style>